/**
 * 自动生成， 请不要手工修改！
 */

export enum NotifyType {
  SYSMSG,
  SHORTMSG,
  SYSMSG_AND_SHORTMSG,
}
